// extracted by mini-css-extract-plugin
export default {"container":"sjkJyP","xs":"n_K3DG","lg":"KfF2RA","image":"_fRz3v","content":"Y8iC0Z","cta":"iGtbcQ"};